import React from "react";
import LookupAdmin, { ColorSwatch, ActiveChip } from "../../components/LookupAdmin";

const config = {
  title: "Origens de Cliente",
  endpoint: "/client-sources",
  labelField: "name",
  fields: [
    { name: "name", label: "Nome", required: true, span: 5 },
    { name: "color", label: "Cor", type: "color", defaultValue: "#3f51b5" },
    { name: "icon", label: "Ícone", span: 3 },
    { name: "description", label: "Descrição", span: 12 },
    { name: "active", label: "Ativo", type: "boolean", defaultValue: true },
  ],
  columns: [
    {
      key: "name",
      label: "Nome",
      render: (s) => (
        <>
          <ColorSwatch color={s.color} />
          {s.name}
        </>
      ),
    },
    { key: "description", label: "Descrição" },
    { key: "active", label: "Status", render: (s) => <ActiveChip active={s.active} /> },
  ],
};

const ClientSources = () => <LookupAdmin config={config} />;

export default ClientSources;
